export class CoolerDoorFilter {
    public IncludeInactive?: boolean;
}

export default CoolerDoorFilter;